import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { searchAPI } from "../../../apis";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getConfig } from "../../../apis";
import DeleteSharedBookmark from "./DeleteSharedCollection";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";
import { axiosInstance } from "../../../functions/axios";

const SharedList = (props) => {
  const isMobile = useIsMobile();

  const { userPopup, setUserPopup, deleteSharedUser, setDarkBackground } =
    props;
  const [deletePopup, setDeletePopup] = useState("");
  const [email, setEmail] = useState("");
  const [id, setId] = useState(null);
  const [users, setUsers] = useState({});
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const user_email = localStorage.getItem("email");

  const params = useParams();
  const { user } = useSelector((state) => state.auth);

  const handleDelete = (user) => {
    setEmail(user.email);
    setId(user.userId);
    setDeletePopup(true);
    setDarkBackground(false);
  };

  const getData = async () => {
    const { data } = await axiosInstance.post(
      searchAPI.sharedUserList,
      {
        userId: user.userId,
        collectionId: params.id,
      },
      getConfig()
    );
    setUsers(data.slice());
  };

  useEffect(() => {
    getData();
  }, [userPopup]);

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  return (
    <>
      {userPopup && (
        <>
          <Draggable
            defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
            cancel={isMobile ? ".new-user-popup" : null}
          >
            <div className="new-user-popup">
              <div className="popup-card">
                <CloseIcon
                  className="cross"
                  onClick={() => {
                    setUserPopup(false);
                    setDarkBackground(false);
                  }}
                />
                <p className="popup-title"></p>
                <div className="header">
                  <div className="col">
                    <p>Email</p>
                  </div>

                  <div className="col">
                    <p>Action</p>
                  </div>
                </div>

                <div className="rows">
                  {users.map((shared_user) => (
                    <div className="row" key={shared_user.email}>
                      <div className="col">{shared_user.email}</div>
                      <div className="col">
                        <ButtonPrimary
                          text="Remove"
                          onClick={() => {
                            handleDelete(shared_user);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Draggable>
        </>
      )}
      {deletePopup && (
        <DeleteSharedBookmark
          deletePopup={deletePopup}
          setDeletePopup={setDeletePopup}
          email={email}
          deleteSharedUser={deleteSharedUser}
          id={id}
          setUserPopup={setUserPopup}
        />
      )}
    </>
  );
};

export default SharedList;
